module.exports = __webpack_public_path__ + "img/2021_michigan_3.d2710b1c.jpg";